import style from './projects-showcase.module.scss';
import Image from 'next/image';
import Link from 'next/link';
import { ButtonHandshkaeGreen } from '@components/shared/buttons/button-handshake-green';
import { techDueDiligenceState } from '../../tech-due-diligence.state';

interface IProjectItem {
  title: string;
  text: string;
  iconSrc: string;
  link: string;
}

const ProjectsShowcase = () => {
  const { title, description, link, items } = techDueDiligenceState.projectsShowcase;

  return (
    <section className={`${style.section}`}>
      <div className={`${style.container} ${style.container_small} ${style.container_margin}`}>
        <h2 className={`${style.container__title} ${style.container__title__margin} ${style.container__title_center}`}>
          {title}
        </h2>
        <div className={`${style.container__description} ${style.container__title_center}`}>{description}</div>
      </div>
      <div className={`${style.container} ${style.container_large}`}>
        <div className={style.cards}>
          {items.map((item: IProjectItem, index: number) => {
            return (
              <Link key={index} href={item.link}>
                <a className={`${style.cards__item} ${style.cards__item_projects}`}>
                  <div className={`${style.cards__item__image} ${style.cards__item__image_middle}`}>
                    <Image alt={item.title} src={item.iconSrc} layout={'fill'} />
                  </div>
                  <div className={`${style.cards__item__title}`}>{item.title}</div>
                  <div className={`${style.cards__item__text} ${style.cards__item__text_projects}`}>{item.text}</div>
                </a>
              </Link>
            );
          })}
        </div>
        <ButtonHandshkaeGreen
          text="See all projects"
          imageUrl="/assets/icons/icn-arrow-right.svg"
          className="white-with-border arrow-hover"
          link={link}
        />
      </div>
    </section>
  );
};

export default ProjectsShowcase;
